import React, { useEffect } from "react"
import { Elements, useStripe } from "@stripe/react-stripe-js"
import { navigate } from "vike/client/router"
import { windowSearchParams } from "aldoo-ra/SearchParams"
import { store } from "aldoo-ra/Store"
import { getStripePromise } from "aldoo-ra/Store/stripe-client"

const stripePromise = getStripePromise()

const PaymentVerification = () => {
  const stripe = useStripe()
  const [verified, setVerified] = React.useState(false)

  const params = windowSearchParams()
  const paymentIntent = params?.payment_intent
  const setupIntent = params?.setup_intent
  const redirectStatus = params?.redirect_status
  const paymentIntentClientSecret = params?.payment_intent_client_secret
  const setupIntentClientSecret = params?.setup_intent_client_secret

  const { onPaymentSuccess, onPaymentError, getFragment } = store

  const PaymentResultVerifyLoading = getFragment("payment-result-verify-loading")

  useEffect(() => {
    const verifyPayment = async () => {
      if (!stripe) return
      if (verified) return

      try {
        const isSetup = !!setupIntent
        const clientSecret = setupIntentClientSecret || paymentIntentClientSecret
        const intentId = setupIntent || paymentIntent

        if (!clientSecret || !intentId || !redirectStatus) {
          console.error("Missing required payment parameters")
          navigate("/")
          return
        }

        const method = isSetup ? "retrieveSetupIntent" : "retrievePaymentIntent"
        const result = await stripe[method](clientSecret)

        const status = isSetup
          ? result.setupIntent?.status
          : result.paymentIntent?.status

        setVerified(true)

        if (status === "succeeded") {
          onPaymentSuccess()
        } else {
          onPaymentError({
            error: `Payment ${status || "failed"}`,
            code: status,
          })
        }
      } catch (error) {
        console.error("Payment verification error:", error)
        setVerified(true)
        onPaymentError({ error: "failed_to_verify_payment" })
      }
    }

    verifyPayment()
  }, [stripe, paymentIntent, setupIntent, redirectStatus, paymentIntentClientSecret, setupIntentClientSecret])

  return <PaymentResultVerifyLoading />
}

const PaymentResult = () => {
  const { paymentInfo, getFragment } = store

  const PaymentResultInvalidSession = getFragment("payment-result-invalid-session")

  useEffect(() => {
    if (paymentInfo) return
    navigate("/")
  }, [paymentInfo])

  const params = windowSearchParams()
  const clientSecret = params?.payment_intent_client_secret || params?.setup_intent_client_secret

  if (!clientSecret) return <PaymentResultInvalidSession />

  return (
    <Elements
      stripe={stripePromise}
      options={{ clientSecret, loader: "always" }}
    >
      <PaymentVerification />
    </Elements>
  )
}

export default PaymentResult
